import providerConfig from './fedapay.config.json'
export default providerConfig;
